import React, { useState, useEffect, useCallback , useRef,memo } from "react";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  Collapse,
  Box,
  Button,
  Paper,
} from "@mui/material";
import { CancelPresentationRounded, KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import useStyles from "./style";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom'
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { CUSTOM_CONSTANTS } from "Constants";
//Services
import HotelApi from "Services/Hotel";

const MytripsPage = () => {
const dispatch = useDispatch();
const [rows, setrows] = useState([]);
const classes = useStyles();
const navigate = useNavigate();

   const getmytrips = useCallback(() => {
  dispatch(showLoader("Loading please wait..."));
  const onSuccess = (res) => {
    dispatch(hideLoader());
 //   console.log("fetched user request data--->",res?.data);
    if (res?.data?.status === true) {
   console.log("fetched active service data--->",res?.data)
      setrows(res?.data?.data);
    } else {
      setrows([]);
    }
  };
  const onFailure = (err) => {
    dispatch(hideLoader());
    dispatch(
      showSnackbar({
        message: err?.response?.data?.message || "Failed to fetch data",
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      })
    );
    //console.log("Get member / partner details Api", err);
  };
  HotelApi.getmytrips().then(onSuccess, onFailure);
}, []);

  useEffect(() => {
    getmytrips();
  }, []);   

  const [openRow, setOpenRow] = useState(null);

  return (
    <Grid container sx={{ height: "100vh" }}>
      {/* Left side table */}
      <Grid item xs={12} md={7} sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom className={classes.spaceme} sx={{fontWeight: "bold" }}>
          My Trips
        </Typography>
        <Paper>
          <Table className={classes.triptable}>
<TableHead>
  <TableRow className={classes.tableheader}>
    <TableCell />
    <TableCell>Booking Id</TableCell>
    <TableCell >Date</TableCell>
    <TableCell >Customer Name</TableCell>
    <TableCell >Driver Name</TableCell>
    <TableCell >Total Amount</TableCell>
    <TableCell >Type</TableCell>
    <TableCell >Payment</TableCell>
    <TableCell >Status</TableCell>
  </TableRow>
</TableHead>

<TableBody>
  {rows.map((row, index) => (
    <React.Fragment key={row.bookingId}>
      <TableRow>
        <TableCell>
          <IconButton
            size="small"
            onClick={() => setOpenRow(openRow === index ? null : index)}
          >
            {openRow === index ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        <TableCell>{row.bookingId}</TableCell>
        <TableCell>
          {new Date(row.tripBookedAt).toLocaleDateString("en-GB")}
        </TableCell>
        <TableCell>{row.user_name}</TableCell>
        <TableCell>{row.driverdetails?.user_name || "-"}</TableCell>
        <TableCell>{row.estimatedFare +" "+ CUSTOM_CONSTANTS.BASE_CURRENCY || "-"}</TableCell>
        <TableCell>{row.service_name}</TableCell>
        <TableCell>{row.paymentMode}</TableCell>
        <TableCell sx={{
              color: row.tripStatus === "CANCELLED" ? "red" : "green",
              fontWeight: "bold",
            }} >
            {row.tripStatus}
        </TableCell>
      </TableRow>

      {/* Expanded Row */}
      <TableRow>
        <TableCell colSpan={9} sx={{ p: 0 }}>
          <Collapse in={openRow === index} timeout="auto" unmountOnExit>
            <Box sx={{ p: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography>
                    <strong>From:</strong> 
                  </Typography >
                    <Typography className={classes.spaceme}>{new Date(row.tripBookedAt).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })} - {new Date(row.tripBookedAt).toLocaleDateString("en-GB")}</Typography>
                  <Typography className={classes.spaceme} >{row.pickupAddress}</Typography>
                  <Typography>
                    <strong>To:</strong> 
                  </Typography>
                  <Typography className={classes.spaceme} >{new Date(row.updatedAt).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })} - {new Date(row.updatedAt).toLocaleDateString("en-GB")}</Typography>
                  <Typography className={classes.spaceme} >{row.dropAddress}</Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography>
                    <strong>Payment:</strong> 
                  </Typography>
                          <Typography className={classes.spaceme}>{row.paymentMode}</Typography>
                  <Typography >
                    <strong>Total Amount:</strong> 
                  </Typography>
                         <Typography className={classes.spaceme} >{row.estimatedFare +" "+ CUSTOM_CONSTANTS.BASE_CURRENCY || "-"}</Typography>
                  <Typography>
                    <strong>Driver Name:</strong> 
                  </Typography>
                          <Typography className={classes.spaceme} >{row.driverdetails?.user_name || "-"}</Typography>
                </Grid>
              </Grid>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  ))}
</TableBody>

          </Table>
        </Paper>
      </Grid>

      {/* Right side static image */}
      <Grid
        item
        xs={12}
        md={5}
        className={classes.rightimage}
      />
    </Grid>
  );
};

export default MytripsPage;
